import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button, Icon } from '@components';
import { ProductFamilyPropType } from '@propTypes';
import { getProductId } from '@modules/utils';

import styles from './styles/index.module.scss';
import { useHeaderContext } from '../../../../../HeaderContext';

const Family = ({
  products,
  onShowCategoryMenu,
  idSelectedFamily,
  isVisible,
}) => {
  const { platformBaseUrl } = useHeaderContext();
  const getClassName = id =>
    cn({
      [styles.familyItem]: true,
      [styles.selectedFamily]: idSelectedFamily === id,
    });
  const onMouseEnter = (id, children) => onShowCategoryMenu({ id, children });

  return (
    <ul className={styles.familyMenu} data-qa="familiesList">
      {products.map(({ id, name, url, children }) => (
        <li className={getClassName(id)} key={id}>
          <Button
            tag="a"
            href={`${platformBaseUrl}${url}`}
            color="transparent"
            className={styles.familyTab}
            onMouseEnter={() => onMouseEnter(id, children)}
          >
            {isVisible && (
              <Icon
                id={getProductId(id)}
                size="18"
                className={styles.familyIcon}
              />
            )}
            {name}
          </Button>
        </li>
      ))}
    </ul>
  );
};

Family.propTypes = {
  products: PropTypes.arrayOf(ProductFamilyPropType).isRequired,
  onShowCategoryMenu: PropTypes.func.isRequired,
  idSelectedFamily: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export default Family;
